export class AlterarSenhaRequestEntity {
  usuario: string;
  senha: string;
  confirmacaoSenha: string;
}
